import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { Link } from 'react-router-dom'

export const Card = styled(Link)`
    width: 86%;
    margin-bottom: 20px;
    position: relative;
    margin-left: 10px;
    cursor: pointer;
   border-radius: 10px;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 33.3%;
    
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 456px;

    
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.4),
        rgba(0, 0, 0, 0.4)
    );
`

export const Available = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: end;
    z-index: 20;
`
export const OverSection = styled(Box)`
    display: flex;
    flex-direction: column;

    justify-content: start;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Content = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: start;
    z-index: 20;
    flex-wrap: wrap;
`
export const ContentDanger = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 20;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 131px;
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.danger};
    height: 44px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 111px;
        height: 34px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 131px;
        height: 44px;
    }
`

export const TypographyContent = styled(Typography)`
    line-height: 36px;
    margin-right: 5px;
    font-family: inherit;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 26px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 36px;
    }
`

export const TypographyTitle = styled(Typography)`
    line-height: 36px;
    margin-right: 5px;
    font-family: inherit;
    color: ${({ theme }) => theme.colors.dark};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 26px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 36px;
    }
`

export const ContentImage = styled(Box)`
    width: 34px;
    height: 34px;
`
